// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-heading h1 {
  font-weight: 700;
  font-size: 2.8rem;
  margin: 0;
}

.buttons-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 2rem;
  position: absolute;
  width: 100%;
  bottom: 0;
}

.buttons-wrapper>button {
  padding: 0.5rem 2.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.5s;
}

.cancel-button {
  border: 1px solid #1e78ff;
  background-color: #fff;
}

.cancel-button:hover {
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px -1px,
    rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px;
}

.cancel-button span {
  font-size: 1.7rem;
  font-weight: 500;
  color: #1e78ff;
}

.submit-button {
  background: #006bff;
  border: 1px solid #006bff;
}

.submit-button:hover {
  border: 1px solid #2043df !important;
  background: #2043df !important;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px -1px,
    rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px;
}

.submit-button.disabled:hover {
  box-shadow: none;
  background: #2043df !important;
}

.submit-button span {
  font-size: 1.7rem;
  font-weight: 500;
  color: #fff;
}

.progress-bar-container {
  width: 100%;
  height: 5px;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 20px;
}

.progress-bar {
  background-color: #154b9b;
  height: 100%;
  transition: width 0.3s ease;
}

.questions {
  display: none;
  transform: translateY(100px);
  opacity: 0;
  transition: all 0.5s ease;
}

.active-question {
  display: block;
  opacity: 1;
  transform: translateY(0);
}

.questions h3 {
  font-size: 1.8rem;
  font-weight: 600;
}

.answers {
  margin-top: 3rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-bottom: 7rem;
}

.answer-button {
  background: #f4f4f4;
  height: fit-content;
  padding: 1rem 2rem;
  border: none;
  border-radius: 38px;
  min-height: 4rem;
}

.answer-button.disabled {
  cursor: not-allowed;
}

button.ans-selected {
  background: #093179;
}

button.ans-selected p {
  color: #ffffff;
}

.answers p {
  text-align: left;
  font-size: 1.4rem;
}

.new-answer {
  margin: 6rem 2rem 0 auto;
}

.input-box {
  margin-bottom: 3rem;
  position: absolute;
  bottom: 3rem;
  width: 98%;
}

.input-box input {
  width: 100%;
  border-radius: 15px;
  background: #f7fbff;
  border: 1px solid #79adf8;
  box-shadow: 0px 4px 8px 0px #0c3c6321;
  padding: 1.5rem 1rem;
  font-size: 1.8rem;
  font-weight: 500;
}

.send-button {
  padding: 0.7rem 2rem;
  border-radius: 12px;
  cursor: pointer;
  background: #006bff;
  border: 1px solid #006bff;
  position: absolute;
  right: 7px;
  top: 8px;
}

.send-button span {
  color: #fff;
  font-size: 1.8rem;
  font-weight: 500;
}

.pick-time-wrapper {
  padding: 0 1.5rem;
}

.pick-time-header {
  text-align: center;
}

.pick-time-header h2 {
  font-size: 20px;
  font-weight: 600;
  color: #0d5c9c;
  margin-bottom: 10px;
}

.pick-time-header p {
  font-size: 1.2rem;
  color: #636363;
}

.dropdown-container {
  position: relative;
  padding: 0 !important;
  border: none !important;
}

.dropdown-container:hover {
  background-color: #fff !important;
}

.dropdown-header {
  display: flex;
  align-items: center;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: fit-content;
  margin: 4px auto 0;
  gap: 1rem;
}

.dropdown-container span,
.dropdown-container>p {
  font-size: 1.2rem;
  color: #636363;
  line-height: 14px;
  text-align: center;
}

.dropdown-header img {
  width: 10px;
  height: 10px;
}

.dropdown-menu {
  position: absolute;
  top: 125%;
  left: 50%;
  transform: translate(-50%, 5%);
  width: 70%;
  border-radius: 4px;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 5px;
  max-height: 200px;
  overflow-y: auto;
}

.dropdown-item {
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
}

.dropdown-item:hover {
  background-color: #efefef;
}

.time-slots {
  width: 85%;
  margin: 2rem auto 0;
  overflow: auto;
  height: 265px;
  padding-right: 1rem;
}

.time-duration-tab {
  border: 1px solid #e7e7e7;
  padding: 3px !important;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 74%;
  margin: 1rem auto 0;
  border-radius: 12px;
  cursor: pointer;
}

.time-duration-tab div {
  border-radius: 8px;
  padding: 1rem;
  width: 50%;
  text-align: center;
}

.time-duration-tab:hover {
  background: #fff !important;
}

.time-duration-tab div.active {
  background: #aecbff;
}

.time-duration-tab>div:hover {
  background-color: #efefef;
}

.time-duration-tab>div.active:hover {
  background-color: #aecbff !important;
}

.time-duration-tab div p {
  font-size: 12px;
  color: #636363 !important;
}

.time-duration-tab div.active p {
  color: #093179;
}

.time-slots>div {
  border: 1px solid #e7e7e7;
  text-align: center;
  padding: 1rem 1rem;
  margin-bottom: 1.2rem;
  border-radius: 12px;
  cursor: pointer;
}

.time-slots>div:hover {
  background-color: #efefef;
}

.time-slots p {
  font-size: 1.3rem;
  font-weight: 500;
  color: #504848;
}

.time-slot-picked {
  background: #093179;
}

.time-slot-disabled {
  background-color: #ececec;
  cursor: not-allowed;
}

.time-slot-disabled p {
  color: #aaa;
}

.time-slot-picked:hover {
  background-color: #093179 !important;
}

.time-slot-picked p {
  color: #ffffff;
}

.time-slot-disabled:hover {
  background-color: #ececec !important;
}

.meeting-details {
  margin-top: 3rem;
  width: 84%;
  position: relative;
}

.meeting-details h3 {
  font-size: 2rem;
  font-weight: 700;
  color: #353535;
}

.scheduled-date-time {
  border-radius: 22px;
  padding: 3.5rem 1.5rem;
  background: #f5faff;
  border: 1px solid #093179;
  display: flex;
}

.scheduled-date>div,
.scheduled-time>div {
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  justify-content: center;
}

.scheduled-date>div span,
.scheduled-time>div span {
  font-size: 1rem;
  font-weight: 600;
  color: #fff;
}

.scheduled-date,
.scheduled-time {
  width: 100%;
}

.scheduled-date-time p {
  font-size: 1.2rem;
  font-weight: 600;
  color: #093179;
  margin-top: 1rem;
  text-align: center;
}

.schedule-demo-bottom {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.schedule-demo-wrapper .buttons-wrapper {
  position: relative;
}

.submitted-box-overlay {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.submitted-box {
  width: 44%;
  background: #fff;
  height: 48%;
  border-radius: 32px;
  border: 1px solid rgba(229, 233, 235, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 70% !important;
  padding: 0 4rem;
}

.scheduled-meeting-details {
  margin-bottom: 3.5rem;
  padding: 4.5rem 2.5rem;
  border: 1px solid #093179;
  border-radius: 22px;
  position: relative;
  width: 84%;
  background: #f5faff;
}

.scheduled-meeting-details>img {
  position: absolute;
  top: -5%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70px;
}

.meeting-date-time {
  display: flex;
  justify-content: center;
  gap: 3rem;
  text-align: center;
}

.meeting-date-time p {
  font-size: 1.6rem;
  margin-top: 0.8rem;
  color: #002974;
  font-weight: 600;
}

.submitted-message {
  text-align: center;
}

.submitted-message h2 {
  font-size: 2.7rem;
  font-weight: 500;
  color: #002974;
  width: 70%;
  margin: 2rem auto;
}

.submitted-message p {
  width: 68%;
  margin: 0 auto 3rem;
}

.done-button {
  padding: 1rem 4.5rem;
  border-radius: 12px;
  cursor: pointer;
  border: none;
  background-color: #002974;
  margin-top: 3rem;
}

.done-button span {
  font-size: 2rem;
  font-weight: 500;
  color: #fff;
}

.error-image {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 1440px) {
  .submitted-box {
    width: 60%;
  }

  .time-duration-tab {
    width: 100%;
  }

  .time-duration-tab div {
    width: 50%;
    text-align: center;
  }
}

@media (max-width: 1024px) {
  .form-heading h1 {
    margin: 0;
  }

  .pick-time-wrapper {
    padding: 0 8rem;
  }

  .time-slots {
    display: flex;
    align-items: center;
    column-gap: 1.8rem;
    flex-wrap: wrap;
    row-gap: 2rem;
    margin: 2rem 0 0 1rem;
    padding: 0;
    height: 90px;
  }

  .time-slots>div {
    width: 30%;
    margin-bottom: 0;
  }

  .schedule-demo-bottom {
    flex-direction: column;
    align-items: flex-start;
    gap: 3rem;
  }

  .submitted-box {
    width: 70%;
    height: 40%;
  }

  .time-duration-tab {
    width: 50%;
    margin-top: 2rem;
  }

  .time-duration-tab div {
    padding: 0.5rem;
  }
}

@media (max-width: 768px) {
  .form-heading {
    text-align: center;
  }

  .progress-bar-container {
    position: sticky;
    top: 2px;
    z-index: 1;
  }

  .pick-time-wrapper {
    padding: 0 4rem;
  }

  .pick-time-header {
    text-align: left;
  }

  .pick-time-header h2 {
    margin: 0;
  }

  .dropdown-header {
    margin: 0;
    gap: 1rem;
  }

  .time-duration-tab {
    margin: 2rem 0 0;
  }

  .dropdown-container span,
  .dropdown-container>p {
    text-align: left;
  }

  .time-slots {
    margin-top: 2rem;
    justify-content: flex-start;
    gap: 2rem;
    height: 125px;
  }

  .time-slots>div {
    width: 40%;
  }

  .scheduled-date-time {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    padding: 2.5rem 2rem;
    gap: 1rem;
  }

  .schedule-demo-wrapper .scheduled-for {
    width: 100%;
  }

  .schedule-demo-wrapper .scheduled-for .scheduled-date {
    margin: 0;
  }

  .schedule-demo-wrapper .buttons-wrapper {
    padding: 0 4rem;
  }

  .submitted-box {
    width: 85%;
    height: 60% !important;
  }

  .scheduled-for>img {
    width: 80px;
    top: -6%;
  }

  .input-box {
    width: 88%;
  }
}

@media (max-width: 576px) {
  .form-heading {
    text-align: left;
  }

  .pick-time-wrapper {
    padding: 0;
  }

  .pick-time-header {
    text-align: left;
  }

  .dropdown-header {
    margin: 0;
  }

  .time-duration-tab {
    margin: 2rem 0 0;
  }

  .time-slots {
    width: 95%;
  }

  .time-slots>div {
    width: 46%;
  }

  .time-slots p {
    font-size: 1.4rem;
  }

  .schedule-demo-wrapper .scheduled-for {
    padding: 0;
  }

  .schedule-demo-wrapper .scheduled-for .scheduled-date-time>div {
    width: 50%;
  }

  .schedule-demo-wrapper .buttons-wrapper {
    padding: 0;
  }

  .scheduled-for {
    width: 75%;
  }

  .scheduled-for>img {
    width: 70px;
  }

  .submitted-message p {
    width: 90%;
  }

  .buttons-wrapper>button {
    padding: 0.5rem 2rem;
  }

  .cancel-button span,
  .submit-button span {
    font-size: 1.9rem;
  }

  .submitted-box {
    width: 95%;
    height: 70% !important;
  }

  .submitted-box-overlay .scheduled-for {
    padding: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/FormComponents/FormComponents.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE;6EAC2E;AAC7E;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B;6EAC2E;AAC7E;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;EACrC,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,8BAA8B;EAC9B,UAAU;EACV,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,qBAAqB;IACrB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;IACT,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,2BAA2B;IAC3B,SAAS;IACT,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".form-heading h1 {\n  font-weight: 700;\n  font-size: 2.8rem;\n  margin: 0;\n}\n\n.buttons-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 2rem;\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n}\n\n.buttons-wrapper>button {\n  padding: 0.5rem 2.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.5s;\n}\n\n.cancel-button {\n  border: 1px solid #1e78ff;\n  background-color: #fff;\n}\n\n.cancel-button:hover {\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px -1px,\n    rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px;\n}\n\n.cancel-button span {\n  font-size: 1.7rem;\n  font-weight: 500;\n  color: #1e78ff;\n}\n\n.submit-button {\n  background: #006bff;\n  border: 1px solid #006bff;\n}\n\n.submit-button:hover {\n  border: 1px solid #2043df !important;\n  background: #2043df !important;\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px -1px,\n    rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px;\n}\n\n.submit-button.disabled:hover {\n  box-shadow: none;\n  background: #2043df !important;\n}\n\n.submit-button span {\n  font-size: 1.7rem;\n  font-weight: 500;\n  color: #fff;\n}\n\n.progress-bar-container {\n  width: 100%;\n  height: 5px;\n  border-radius: 10px;\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\n.progress-bar {\n  background-color: #154b9b;\n  height: 100%;\n  transition: width 0.3s ease;\n}\n\n.questions {\n  display: none;\n  transform: translateY(100px);\n  opacity: 0;\n  transition: all 0.5s ease;\n}\n\n.active-question {\n  display: block;\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.questions h3 {\n  font-size: 1.8rem;\n  font-weight: 600;\n}\n\n.answers {\n  margin-top: 3rem;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n  margin-bottom: 7rem;\n}\n\n.answer-button {\n  background: #f4f4f4;\n  height: fit-content;\n  padding: 1rem 2rem;\n  border: none;\n  border-radius: 38px;\n  min-height: 4rem;\n}\n\n.answer-button.disabled {\n  cursor: not-allowed;\n}\n\nbutton.ans-selected {\n  background: #093179;\n}\n\nbutton.ans-selected p {\n  color: #ffffff;\n}\n\n.answers p {\n  text-align: left;\n  font-size: 1.4rem;\n}\n\n.new-answer {\n  margin: 6rem 2rem 0 auto;\n}\n\n.input-box {\n  margin-bottom: 3rem;\n  position: absolute;\n  bottom: 3rem;\n  width: 98%;\n}\n\n.input-box input {\n  width: 100%;\n  border-radius: 15px;\n  background: #f7fbff;\n  border: 1px solid #79adf8;\n  box-shadow: 0px 4px 8px 0px #0c3c6321;\n  padding: 1.5rem 1rem;\n  font-size: 1.8rem;\n  font-weight: 500;\n}\n\n.send-button {\n  padding: 0.7rem 2rem;\n  border-radius: 12px;\n  cursor: pointer;\n  background: #006bff;\n  border: 1px solid #006bff;\n  position: absolute;\n  right: 7px;\n  top: 8px;\n}\n\n.send-button span {\n  color: #fff;\n  font-size: 1.8rem;\n  font-weight: 500;\n}\n\n.pick-time-wrapper {\n  padding: 0 1.5rem;\n}\n\n.pick-time-header {\n  text-align: center;\n}\n\n.pick-time-header h2 {\n  font-size: 20px;\n  font-weight: 600;\n  color: #0d5c9c;\n  margin-bottom: 10px;\n}\n\n.pick-time-header p {\n  font-size: 1.2rem;\n  color: #636363;\n}\n\n.dropdown-container {\n  position: relative;\n  padding: 0 !important;\n  border: none !important;\n}\n\n.dropdown-container:hover {\n  background-color: #fff !important;\n}\n\n.dropdown-header {\n  display: flex;\n  align-items: center;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  width: fit-content;\n  margin: 4px auto 0;\n  gap: 1rem;\n}\n\n.dropdown-container span,\n.dropdown-container>p {\n  font-size: 1.2rem;\n  color: #636363;\n  line-height: 14px;\n  text-align: center;\n}\n\n.dropdown-header img {\n  width: 10px;\n  height: 10px;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: 125%;\n  left: 50%;\n  transform: translate(-50%, 5%);\n  width: 70%;\n  border-radius: 4px;\n  background-color: white;\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 5px;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.dropdown-item {\n  padding: 10px;\n  cursor: pointer;\n  border-bottom: 1px solid #eee;\n}\n\n.dropdown-item:hover {\n  background-color: #efefef;\n}\n\n.time-slots {\n  width: 85%;\n  margin: 2rem auto 0;\n  overflow: auto;\n  height: 265px;\n  padding-right: 1rem;\n}\n\n.time-duration-tab {\n  border: 1px solid #e7e7e7;\n  padding: 3px !important;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  width: 74%;\n  margin: 1rem auto 0;\n  border-radius: 12px;\n  cursor: pointer;\n}\n\n.time-duration-tab div {\n  border-radius: 8px;\n  padding: 1rem;\n  width: 50%;\n  text-align: center;\n}\n\n.time-duration-tab:hover {\n  background: #fff !important;\n}\n\n.time-duration-tab div.active {\n  background: #aecbff;\n}\n\n.time-duration-tab>div:hover {\n  background-color: #efefef;\n}\n\n.time-duration-tab>div.active:hover {\n  background-color: #aecbff !important;\n}\n\n.time-duration-tab div p {\n  font-size: 12px;\n  color: #636363 !important;\n}\n\n.time-duration-tab div.active p {\n  color: #093179;\n}\n\n.time-slots>div {\n  border: 1px solid #e7e7e7;\n  text-align: center;\n  padding: 1rem 1rem;\n  margin-bottom: 1.2rem;\n  border-radius: 12px;\n  cursor: pointer;\n}\n\n.time-slots>div:hover {\n  background-color: #efefef;\n}\n\n.time-slots p {\n  font-size: 1.3rem;\n  font-weight: 500;\n  color: #504848;\n}\n\n.time-slot-picked {\n  background: #093179;\n}\n\n.time-slot-disabled {\n  background-color: #ececec;\n  cursor: not-allowed;\n}\n\n.time-slot-disabled p {\n  color: #aaa;\n}\n\n.time-slot-picked:hover {\n  background-color: #093179 !important;\n}\n\n.time-slot-picked p {\n  color: #ffffff;\n}\n\n.time-slot-disabled:hover {\n  background-color: #ececec !important;\n}\n\n.meeting-details {\n  margin-top: 3rem;\n  width: 84%;\n  position: relative;\n}\n\n.meeting-details h3 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #353535;\n}\n\n.scheduled-date-time {\n  border-radius: 22px;\n  padding: 3.5rem 1.5rem;\n  background: #f5faff;\n  border: 1px solid #093179;\n  display: flex;\n}\n\n.scheduled-date>div,\n.scheduled-time>div {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  width: 100%;\n  justify-content: center;\n}\n\n.scheduled-date>div span,\n.scheduled-time>div span {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #fff;\n}\n\n.scheduled-date,\n.scheduled-time {\n  width: 100%;\n}\n\n.scheduled-date-time p {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #093179;\n  margin-top: 1rem;\n  text-align: center;\n}\n\n.schedule-demo-bottom {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n}\n\n.schedule-demo-wrapper .buttons-wrapper {\n  position: relative;\n}\n\n.submitted-box-overlay {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 100;\n}\n\n.submitted-box {\n  width: 44%;\n  background: #fff;\n  height: 48%;\n  border-radius: 32px;\n  border: 1px solid rgba(229, 233, 235, 1);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  height: 70% !important;\n  padding: 0 4rem;\n}\n\n.scheduled-meeting-details {\n  margin-bottom: 3.5rem;\n  padding: 4.5rem 2.5rem;\n  border: 1px solid #093179;\n  border-radius: 22px;\n  position: relative;\n  width: 84%;\n  background: #f5faff;\n}\n\n.scheduled-meeting-details>img {\n  position: absolute;\n  top: -5%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 70px;\n}\n\n.meeting-date-time {\n  display: flex;\n  justify-content: center;\n  gap: 3rem;\n  text-align: center;\n}\n\n.meeting-date-time p {\n  font-size: 1.6rem;\n  margin-top: 0.8rem;\n  color: #002974;\n  font-weight: 600;\n}\n\n.submitted-message {\n  text-align: center;\n}\n\n.submitted-message h2 {\n  font-size: 2.7rem;\n  font-weight: 500;\n  color: #002974;\n  width: 70%;\n  margin: 2rem auto;\n}\n\n.submitted-message p {\n  width: 68%;\n  margin: 0 auto 3rem;\n}\n\n.done-button {\n  padding: 1rem 4.5rem;\n  border-radius: 12px;\n  cursor: pointer;\n  border: none;\n  background-color: #002974;\n  margin-top: 3rem;\n}\n\n.done-button span {\n  font-size: 2rem;\n  font-weight: 500;\n  color: #fff;\n}\n\n.error-image {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@media (max-width: 1440px) {\n  .submitted-box {\n    width: 60%;\n  }\n\n  .time-duration-tab {\n    width: 100%;\n  }\n\n  .time-duration-tab div {\n    width: 50%;\n    text-align: center;\n  }\n}\n\n@media (max-width: 1024px) {\n  .form-heading h1 {\n    margin: 0;\n  }\n\n  .pick-time-wrapper {\n    padding: 0 8rem;\n  }\n\n  .time-slots {\n    display: flex;\n    align-items: center;\n    column-gap: 1.8rem;\n    flex-wrap: wrap;\n    row-gap: 2rem;\n    margin: 2rem 0 0 1rem;\n    padding: 0;\n    height: 90px;\n  }\n\n  .time-slots>div {\n    width: 30%;\n    margin-bottom: 0;\n  }\n\n  .schedule-demo-bottom {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 3rem;\n  }\n\n  .submitted-box {\n    width: 70%;\n    height: 40%;\n  }\n\n  .time-duration-tab {\n    width: 50%;\n    margin-top: 2rem;\n  }\n\n  .time-duration-tab div {\n    padding: 0.5rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .form-heading {\n    text-align: center;\n  }\n\n  .progress-bar-container {\n    position: sticky;\n    top: 2px;\n    z-index: 1;\n  }\n\n  .pick-time-wrapper {\n    padding: 0 4rem;\n  }\n\n  .pick-time-header {\n    text-align: left;\n  }\n\n  .pick-time-header h2 {\n    margin: 0;\n  }\n\n  .dropdown-header {\n    margin: 0;\n    gap: 1rem;\n  }\n\n  .time-duration-tab {\n    margin: 2rem 0 0;\n  }\n\n  .dropdown-container span,\n  .dropdown-container>p {\n    text-align: left;\n  }\n\n  .time-slots {\n    margin-top: 2rem;\n    justify-content: flex-start;\n    gap: 2rem;\n    height: 125px;\n  }\n\n  .time-slots>div {\n    width: 40%;\n  }\n\n  .scheduled-date-time {\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    padding: 2.5rem 2rem;\n    gap: 1rem;\n  }\n\n  .schedule-demo-wrapper .scheduled-for {\n    width: 100%;\n  }\n\n  .schedule-demo-wrapper .scheduled-for .scheduled-date {\n    margin: 0;\n  }\n\n  .schedule-demo-wrapper .buttons-wrapper {\n    padding: 0 4rem;\n  }\n\n  .submitted-box {\n    width: 85%;\n    height: 60% !important;\n  }\n\n  .scheduled-for>img {\n    width: 80px;\n    top: -6%;\n  }\n\n  .input-box {\n    width: 88%;\n  }\n}\n\n@media (max-width: 576px) {\n  .form-heading {\n    text-align: left;\n  }\n\n  .pick-time-wrapper {\n    padding: 0;\n  }\n\n  .pick-time-header {\n    text-align: left;\n  }\n\n  .dropdown-header {\n    margin: 0;\n  }\n\n  .time-duration-tab {\n    margin: 2rem 0 0;\n  }\n\n  .time-slots {\n    width: 95%;\n  }\n\n  .time-slots>div {\n    width: 46%;\n  }\n\n  .time-slots p {\n    font-size: 1.4rem;\n  }\n\n  .schedule-demo-wrapper .scheduled-for {\n    padding: 0;\n  }\n\n  .schedule-demo-wrapper .scheduled-for .scheduled-date-time>div {\n    width: 50%;\n  }\n\n  .schedule-demo-wrapper .buttons-wrapper {\n    padding: 0;\n  }\n\n  .scheduled-for {\n    width: 75%;\n  }\n\n  .scheduled-for>img {\n    width: 70px;\n  }\n\n  .submitted-message p {\n    width: 90%;\n  }\n\n  .buttons-wrapper>button {\n    padding: 0.5rem 2rem;\n  }\n\n  .cancel-button span,\n  .submit-button span {\n    font-size: 1.9rem;\n  }\n\n  .submitted-box {\n    width: 95%;\n    height: 70% !important;\n  }\n\n  .submitted-box-overlay .scheduled-for {\n    padding: 0 !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
